import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnInit,
	OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ProductPackagesServiceProvider } from '@mob-providers/product-packages-service/product-packages.data.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { QuoteUpdateService } from '@services/quote/quote-update.service';

@Component({
	selector: 'quote-create-package-block',
	template: require('./quote-create-package-block.html'),
	styles: [require('./quote-create-package-block.scss')]
})
export class QuoteCreatePackageComponent implements OnInit, OnDestroy {
	@Input('index') index;
	@Input('currencySymbol') currencySymbol;
	@Input('taxPercentage') taxPercentage;
	@Input('isFixed') isFixed?;
	productsNames;
	chosenItemChanged: Subject<object> = new Subject<object>();
	unsubscribe: Subject<void> = new Subject<void>();
	packageTemplateId = -1;
	chosenItem;
	price;
	chosenProduct: boolean;
	chosenPackage: boolean;
	chosenItemDescription: string;
	selectOptionGroups: any = [];
	_paskagesLength: number;

	get product() {
		return this.chosenProduct;
	}
	get packageItem(): boolean {
		return this.chosenPackage;
	}

	get packagesLength(): number {
		return this._paskagesLength;
	}

	get productsName(): number {
		return this.productsNames;
	}

	@Input('productsName')
	set productsName(value) {
		this.productsNames = value;
		this.setSelectGroups(value);
	}

	@Input('product')
	set product(value: boolean) {
		this.chosenProduct = value;
		this.setChosenItem();
	}

	@Input('package')
	set packageItem(value: boolean) {
		this.chosenPackage = value;
		this.setChosenItem();
	}

	@Input('packagesLength')
	set packagesLengthValue(value: number) {
		if (value <= 1 && this.chosenItem.recommended) {
			this.chosenItem.recommended = false;
		}
		this._paskagesLength = value;
	}

	@Output() deletePackage = new EventEmitter();
	@Output() checkRecommended = new EventEmitter();
	@Output() changeProduct = new EventEmitter();

	constructor(
		private productPackagesService: ProductPackagesServiceProvider,
		private invoiceDataService: InvoicesDataProvider,
		private stringModifier: StringModifierServiceProvider,
		private quoteUpdateService: QuoteUpdateService
	) {}

	ngOnInit(): void {
		this.validateQiantity();
		this.validateDiscount();
		this.subscribeToProductChanges();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	setSelectGroups(products): void {
		const packageFilter = {
			type: 'PACKAGE',
			nameOfGroup: 'Packages'
		};

		const productFilter = {
			type: 'ADD_ON',
			nameOfGroup: 'Products'
		};

		const {
			packages,
			addons,
			discounts
		} = QuoteUpdateService.setPackagesAndAddons(products);

		if (packages.length > 0) {
			this.selectOptionGroups.push(packageFilter);
		}

		if (this.isFixed) {
			addons.concat(discounts);
		}

		if (addons.length > 0) {
			this.selectOptionGroups.push(productFilter);
		}
	}

	removePackage(index): void {
		const objectToEmit = {
			index,
			type: this.packageItem ? 'package' : 'product'
		};
		this.deletePackage.emit(objectToEmit);
	}

	emitProductChange(): void {
		const objToEmit = {
			index: this.index,
			type: this.packageItem ? 'package' : 'product',
			product: this.chosenItem
		};
		this.changeProduct.emit(objToEmit);
	}

	validatePrice(): void {
		this.chosenItem.price = +this.chosenItem.price;
		this.chosenItem.price = this.chosenItem.price.toFixed(2);
	}

	validateQiantity(): void {
		this.chosenItem.quantity = +this.chosenItem.quantity;
		this.chosenItem.quantity = this.chosenItem.quantity.toFixed(2);
	}

	validateDiscount(): void {
		this.chosenItem.discount = +this.chosenItem.discount;
		this.chosenItem.discount = this.chosenItem.discount.toFixed(2);
	}

	changeDiscountAmount(discount): void {
		this.chosenItem.discount = discount;
		this.setNewChosenItemValues();
	}

	changePriceAmount(price): void {
		this.chosenItem.price = price;
		this.setNewChosenItemValues();
	}

	checkKey(event): void {
		if (
			event.code === 189 ||
			event.code === 109 ||
			event.key === '-' ||
			event.code === 69
		) {
			event.preventDefault();
		}
	}

	validateInputsValues(): void {
		if (this.chosenItem.discount < 0) {
			this.chosenItem.discount = 0;
		}
		if (this.chosenItem.discount > 100) {
			this.chosenItem.discount = 100;
		}
		if (this.chosenItem.quantity < 0.1) {
			this.chosenItem.quantity = 1;
		}
		if (this.chosenItem.price < 0) {
			this.chosenItem.price = 0;
		}
	}

	setNewChosenItemValues(): void {
		this.chosenItemChanged.next(this.chosenItem);
	}

	calculateAmount(item, needToEmit?): void {
		this.validateInputsValues();
		const data = {
			products: this.validateProductsValues(item),
			tax: this.taxPercentage,
			currencySymbol: this.currencySymbol
		};
		this.invoiceDataService.calculateInvoiceSummary(data).subscribe(
			(calculatedData): void => {
				this.chosenItem.amount = calculatedData.items[0].summary.total;
				this.chosenItem.summary = calculatedData.items[0].summary;
				if (needToEmit) {
					this.emitProductChange();
				}
				this.quoteUpdateService.setNextUpdateProduct(
					this.index,
					this.chosenItem
				);
			},
			(error): void => console.log(error)
		);
	}

	setRecommendedPackage(value): void {
		if (value && this.chosenItem.mandatory) {
			this.chosenItem.mandatory = false;
		} else {
			this.chosenItem.recommended = value;
		}
	}

	setMandatoryPackage(value): void {
		if (value && this.chosenItem.recommended) {
			this.chosenItem.recommended = false;
		} else {
			this.chosenItem.mandatory = value;
		}
	}

	updatePackage(productId): void {
		const propertiesToKeep = {
			recommended: this.chosenItem.recommended,
			mandatory: this.chosenItem.mandatory
		};

		this.packageTemplateId = parseInt(productId);
		if (productId === '-1') {
			this.chosenItem = Object.assign(this.chosenItem, this.getDefaultValue());
		} else {
			this.chosenItem = JSON.parse(
				JSON.stringify(
					this.productsNames.filter(product => product.id === +productId)[0]
				)
			);
		}
		this.chosenItem = Object.assign(this.chosenItem, {
			fromSettings: true,
			discount: 0,
			quantity: 1,
			summary: {
				total: 0
			},
			recommended: propertiesToKeep.recommended,
			mandatory: propertiesToKeep.mandatory
		});

		this.chosenItemDescription = this.chosenItem.description;

		this.validatePrice();
		this.calculateAmount(this.chosenItem, true);
	}

	limitDecimalInput(event) {
		const value = this.chosenItem.quantity;
		if (
			value !== null &&
			!Number.isNaN(value) &&
			value.toString().split('.')[1] &&
			value.toString().split('.')[1].length > 2
		) {
			event.preventDefault();
			this.chosenItem.quantity = this.chosenItem.quantity.toFixed(2);
		}
	}

	private validateProductsValues(item) {
		const validatedProduct = JSON.parse(JSON.stringify(item));
		return [
			Object.assign(validatedProduct, {
				discount: this.stringModifier.convertAmountIntoNumber(
					validatedProduct.discount
				),
				price: this.stringModifier.convertAmountIntoNumber(
					validatedProduct.price
				)
			})
		];
	}

	private subscribeToProductChanges(): void {
		this.chosenItemChanged
			.takeUntil(this.unsubscribe)
			.debounceTime(500)
			.subscribe((data): void => this.calculateAmount(data));
	}

	private setChosenItem(): void {
		this.chosenItem = this.chosenProduct
			? this.chosenProduct
			: this.chosenPackage;
		this.chosenItemDescription = this.chosenItem.description;
		if (this.productsNames) {
			this.productsNames.forEach((product): void => {
				switch (product.id) {
					case this.chosenItem.id:
						this.packageTemplateId = this.chosenItem.id;
						break;
					case null:
						this.packageTemplateId = -1;
						break;
					default:
						break;
				}
			});
		}
		if (this.chosenItem.id === null) {
			this.calculateAmount(this.chosenItem);
		}
		this.validatePrice();
	}

	private getDefaultValue() {
		return {
			description: '',
			id: null,
			name: '',
			price: 0,
			quantity: 0,
			discount: 0,
			summary: {
				total: 0
			},
			taxValue: 0,
			tax: 'NO_TAX',
			recommended: false,
			mandatory: false,
			type: this.product ? 'ADD_ON' : 'PACKAGE'
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=xqsfzqb50j!./web/modern/components/quotes/common/quote-create-package-block/quote-create-package-block.ts